
export { fosserProducts } from './fosserProducts';
export { castrolProducts } from './castrolProducts';
export { liquimolyProducts } from './liquimolyProducts';
export { motulProducts } from './motulProducts';
export { supermaxProducts } from './supermaxProducts';
export { proficarProducts } from './proficarProducts';
export { miscProducts } from './miscProducts';

import { fosserProducts } from './fosserProducts';
import { castrolProducts } from './castrolProducts';
import { liquimolyProducts } from './liquimolyProducts';
import { motulProducts } from './motulProducts';
import { supermaxProducts } from './supermaxProducts';
import { proficarProducts } from './proficarProducts';
import { miscProducts } from './miscProducts';

export const shopProducts = [
  ...fosserProducts,
  ...castrolProducts,
  ...liquimolyProducts,
  ...motulProducts,
  ...supermaxProducts,
  ...proficarProducts,
  ...miscProducts,
];
